import React from 'react';
import { XIcon } from 'lucide-react';
import { AGITATE_HEADLINE, AGITATE_PUNCH, AGITATE_STATEMENT_BOTTOM, AGITATE_STATEMENT_TOP, agitateLines, agitateStory } from '../data/poolContent';
export function AgitateSection() {
  return <section className="w-full bg-abyss-950 py-14 sm:py-20" aria-labelledby="agitate-title" data-id="element-21" data-mp="210efzeejkyzy">
      <div className="mx-auto max-w-5xl px-5" data-id="element-22" data-mp="1w2mhu2nb0gnb">
        <h2 id="agitate-title" className="max-w-3xl font-display text-[2rem] font-bold uppercase leading-none text-frost-50 sm:text-[2.8rem]" data-id="element-23" data-mp="18c8swl00mxwy">
          {AGITATE_HEADLINE}
        </h2>

        <div className="mt-10 grid gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-14" data-id="element-24" data-mp="1i2lca9w3gl1i">
          <div className="border-l-2 border-pool/60 pl-5" data-id="element-25" data-mp="1dbv82zzemo8e">
            {agitateStory.map(line => <p key={line} className="py-1.5 text-[15px] leading-snug text-frost-100 sm:text-[16px]" data-id="element-26" data-mp="plirl0q3fj67">
                {line}
              </p>)}
            <p className="mt-4 text-[15px] font-semibold leading-snug text-alert sm:text-[16px]" data-id="element-27" data-mp="kkv3onx5vig7">
              {AGITATE_PUNCH}
            </p>
          </div>

          <ul className="border-t border-abyss-600" data-id="element-28" data-mp="xcdsokcijcc9">
            {agitateLines.map(line => <li key={line} className="flex items-start gap-3 border-b border-abyss-600 py-3.5" data-id="element-29" data-mp="1256x1742kint">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-alert" strokeWidth={2.5} aria-hidden="true" data-id="element-30" data-mp="17272pgx0bjee" />
                <span className="text-[14px] font-medium leading-snug text-frost-100" data-id="element-31" data-mp="ee1h6ry4pqdi">{line}</span>
              </li>)}
          </ul>
        </div>

        <p className="mx-auto mt-14 max-w-3xl text-center font-display text-[2rem] font-bold uppercase leading-[1.02] text-frost-50 sm:text-[3rem]" data-id="element-32" data-mp="jfqvcggnek5t">
          {AGITATE_STATEMENT_TOP}
          <span className="block text-aqua" data-id="element-33" data-mp="1us9q3jpz816o">{AGITATE_STATEMENT_BOTTOM}</span>
        </p>
      </div>
    </section>;
}